import { useCallback, useEffect, useMemo } from "react";

type TVibrationPattern = number | number[];

export const useVibration = () => {
  const isVibrationSupported = useMemo(
    () => typeof window !== "undefined" && "vibrate" in navigator,
    []
  );

  const vibratePattern = useMemo(
    () => ({
      short: 50,
      medium: 100,
      long: 200,
      success: [100, 50, 100],
      error: [200, 100, 200, 100, 200],
      notification: [100, 200, 100],
      confirmation: [300],
    }),
    []
  );

  const vibrate = useCallback(
    (pattern: TVibrationPattern = vibratePattern.success) => {
      if (!isVibrationSupported) {
        console.warn("Vibration is not supported in your device!");
        return;
      }

      // Try-catch for extra safety
      try {
        navigator.vibrate(pattern);
      } catch (error) {
        console.warn("Vibration failed:", error);
      }
    },
    [isVibrationSupported, vibratePattern.success]
  );

  // Clean any ongoing vibration on component unmount
  useEffect(() => {
    return () => {
      if (isVibrationSupported) {
        navigator.vibrate(0);
      }
    };
  }, [isVibrationSupported]);

  return { vibrate, pattern: vibratePattern, isVibrationSupported };
};
